<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <h1>Can & Can End Inspection</h1>
        <h1>Technical Data (Before Production)</h1>

        <div :class="{ dimmed: localCanEndInspection.status !== undefined }">
        <v-text-field
          filled
          data-cy="FormCanEndInspection-supplier"
          :label="$$t('supplier')"
          v-model="localCanEndInspection.supplier"
        />
        <AdminTextField
          data-cy="FormCanEndInspection-date"
          :label="$$t('date')"
          v-model="localCanEndInspection.date"
          v-on:keyup.enter="goNext($event.target)"
        />
        <v-select
          filled
          data-cy="FormCanEndInspection-canningCode"
          :label="$$t('canningCode')"
          v-model="localCanEndInspection.canningCode"
          :items="canningCodeItems"
        />
        <v-checkbox
          v-model="localCanEndInspection.oneM"
          :label="$$t('1M')"
          data-cy="FormCanEndInspection-oneM"
        ></v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.a2Percent"
          :label="$$t('a2Percent')"
          data-cy="FormCanEndInspection-a2Percent"
        ></v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.tallCan"
          label="Tall Can"
          data-cy="FormCanEndInspection-tallCan"
        ></v-checkbox>
        <v-select
          :items="['Somme 550', 'Somme 880']"
          filled
          data-cy="FormCanEndInspection-seamerUsed"
          :label="$$t('seamerUsed')"
          v-model="localCanEndInspection.seamerUsed"
        ></v-select>
          <v-text-field
          filled
          data-cy="FormCanEndInspection-supplierCanCode"
          :label="$$t('supplierCanCode')"
          v-model="localCanEndInspection.supplierCanCode"
        />
        <h1>Visual Inspection - Are there any of the following defects:</h1>
        <v-checkbox
          v-model="localCanEndInspection.cansWithSeamDefects"
          :label="$$t('cansWithSeamDefects')"
          data-cy="FormCanEndInspection-date"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.cansWithSeamDefectsCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.dentedCans"
          :label="$$t('dentedCans')"
          data-cy="FormCanEndInspection-dentedCans"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.dentedCansCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.rustedCans"
          :label="$$t('rustedCans')"
          data-cy="FormCanEndInspection-rustedCans"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.rustedCansCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.scratchedCans"
          :label="$$t('scratchedCans')"
          data-cy="FormCanEndInspection-scratchedCans"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.scratchedCansCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.foreignObjectsInCans"
          :label="$$t('foreignObjectsInCans')"
          data-cy="FormCanEndInspection-foreignObjectsInCans"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.foreignObjectsInCansCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.defectiveWeldingOnCans"
          :label="$$t('defectiveWeldingOnCans')"
          data-cy="FormCanEndInspection-defectiveWeldingOnCans"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.defectiveWeldingOnCansCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.canEndsWithoutCompound"
          :label="$$t('canEndsWithoutCompound')"
          data-cy="FormCanEndInspection-canEndsWithoutCompound"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.canEndsWithoutCompoundCount"
              filled
              label="Number of Can Ends"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.scratchedCanEnds"
          :label="$$t('scratchedCanEnds')"
          data-cy="FormCanEndInspection-scratchedCanEnds"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.scratchedCanEndsCount"
              filled
              label="Number of Can Ends"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-text-field
          filled
          data-cy="FormCanEndInspection-numberOfCansNotSuitableForCanning"
          :label="$$t('numberOfCansNotSuitableForCanning')"
          v-model="localCanEndInspection.numberOfCansNotSuitableForCanning"
          readonly
        />
        <v-text-field
          filled
          data-cy="FormCanEndInspection-numberOfCanEndsNotSuitableForCanning"
          :label="$$t('numberOfCanEndsNotSuitableForCanning')"
          v-model="localCanEndInspection.numberOfCanEndsNotSuitableForCanning"
          readonly
        />
        <h1>Visual Inspection: Cans & Ends During Canning</h1>
        <br/>
        <h2>Criteria: Cans - Any of the following visible:</h2>
        <v-checkbox
          v-model="localCanEndInspection.duringCanningDentedCans"
          :label="$$t('duringCanningDentedCans')"
          data-cy="FormCanEndInspection-duringCanningDentedCans"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.duringCanningDentedCansCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.duringCanningScratchedCans"
          :label="$$t('duringCanningScratchedCans')"
          data-cy="FormCanEndInspection-duringCanningScratchedCans"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.duringCanningScratchedCansCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.duringCanningDirtyCans"
          :label="$$t('duringCanningDirtyCans')"
          data-cy="FormCanEndInspection-duringCanningDirtyCans"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.duringCanningDirtyCansCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.duringCanningDamagedLacquer"
          :label="$$t('duringCanningDamagedLacquer')"
          data-cy="FormCanEndInspection-duringCanningDamagedLacquer"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.duringCanningDamagedLacquerCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.duringCanningAnyOtherIrregularities"
          :label="$$t('duringCanningAnyOtherIrregularities')"
          data-cy="FormCanEndInspection-duringCanningAnyOtherIrregularities"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.duringCanningAnyOtherIrregularitiesCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.duringCanningCansWashed"
          :label="$$t('duringCanningCansWashed')"
          data-cy="FormCanEndInspection-duringCanningCansWashed"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.duringCanningCansWashedCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-text-field
          filled
          data-cy="FormCanEndInspection-supplierCanEndCode"
          :label="$$t('supplierCanEndCode')"
          v-model="localCanEndInspection.supplierCanEndCode"
        />
        <h1>Criteria: Can Ends - Any of the following visible:</h1>
        <v-checkbox
          v-model="localCanEndInspection.canEndsDamagedEnds"
          :label="$$t('canEndsDamagedEnds')"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.canEndsDamagedEndsCount"
              filled
              label="Number of Can Ends"
            ></v-text-field>
          </template>
        </v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.canEndRustedEnds"
          :label="$$t('canEndRustedEnds')"
          data-cy="FormCanEndInspection-canEndRustedEnds"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.canEndRustedEndsCount"
              filled
              label="Number of Can Ends"
            ></v-text-field>
          </template></v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.canEndDamagedCompound"
          :label="$$t('canEndDamagedCompound')"
          data-cy="FormCanEndInspection-canEndDamagedCompound"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.canEndDamagedCompoundCount"
              filled
              label="Number of Cans"
            ></v-text-field>
          </template></v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.canEndDirtyEnds"
          :label="$$t('canEndDirtyEnds')"
          data-cy="FormCanEndInspection-canEndDirtyEnds"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="localCanEndInspection.canEndDirtyEndsCount"
              filled
              label="Number of Can Ends"
            ></v-text-field>
          </template></v-checkbox>
        <h1>Criteria: Code On Ends</h1>
        <v-checkbox
          v-model="localCanEndInspection.codeOnEndsCanningCodeLegible"
          :label="$$t('codeOnEndsCanningCodeLegible')"
          data-cy="FormCanEndInspection-codeOnEndsCanningCodeLegible"
        ></v-checkbox>
        <v-checkbox
          v-model="localCanEndInspection.codeOnEndsCorrectCanningCode"
          :label="$$t('codeOnEndsCorrectCanningCode')"
          data-cy="FormCanEndInspection-codeOnEndsCorrectCanningCode"
        ></v-checkbox>
        <v-text-field
          filled
          data-cy="FormCanEndInspection-comments"
          :label="$$t('comments')"
          v-model="localCanEndInspection.comments"
        />
        <v-text-field
          filled
          data-cy="FormCanEndInspection-correctiveAction"
          :label="$$t('correctiveAction')"
          v-model="localCanEndInspection.correctiveAction"
        />
        </div>
        <hr class="mb-5 mt-5" />
        <div :class="{ dimmed: localCanEndInspection.status !== undefined }">
          <SignVerification role="Process Controller" title="Requested By"
            v-model="localCanEndInspection.requestedBySignature" />
          <v-btn block color="success" @click="handover('Ready to be verified')"
            data-cy="FormCanEndInspection-handover-requestedBySignature"
          >
            Handover
          </v-btn>
        </div>
        <hr class="mb-5 mt-5" />
        <div :class="{ dimmed: localCanEndInspection.status !== 'Ready to be verified' }">
          <SignVerification role="Production Manager" title="Verified By"
            v-model="localCanEndInspection.verifiedBySignature" />
          <v-btn block color="success" @click="handover('Ready for NRCS')"
            data-cy="FormCanEndInspection-handover-verifiedBySignature">Handover</v-btn>
        </div>
        <hr class="mb-5 mt-5" />
        <div :class="{ dimmed: localCanEndInspection.status !== 'Ready for NRCS' }">
          <SignVerification role="Nrcs" title="NRCS Inspector"
            v-model="localCanEndInspection.ncrsSignature" />
          <br />
          <v-row>
            <v-col cols="12" class="mb-10">
              <v-btn block color="success" @click="handover('Completed')"
                data-cy="FormCanEndInspection-handover-completed"
              >
                Completed
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <div v-if="!isCompleted" class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormCanEndInspection-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormCanEndInspection-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import AdminTextField from './AdminTextField.vue';
import formChecklist from './formChecklist';
import SignVerification from './SignVerification.vue';

export default {
  name: 'FormCanEndInspection',
  module: 'CanEndInspection',
  components: {
    AdminTextField,
    SignVerification,
  },
  mixins: [formChecklist, loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    CanEndInspection: {
      type: Object,
      default: undefined,
    },
    stockItem: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localCanEndInspection
      */
      localCanEndInspection: {
        date: this.formatDate(new Date()),
      },
    };
  },
  computed: {
    canningCodeItems() {
      const { stockItem } = this;
      if (stockItem) {
        const dt = this.formatDate(stockItem.productionDate);
        return [`AO-${dt}`, `SP-${dt}`];
      }
      return [];
    },
  },
  watch: {
    CanEndInspection() {
      this.localCanEndInspection = this.CanEndInspection;
    },
    localCanEndInspection: {
      immediate: true,
      deep: true,
      handler() {
        this.calculateTotals();
      },
    },
  },
  created() {
    this.localCanEndInspection = this.CanEndInspection;
  },
  methods: {
    calculateTotals() {
      console.debug('calculating totals');
      const {
        cansWithSeamDefectsCount,
        dentedCansCountCount,
        rustedCansCount,
        scratchedCansCount,
        foreignObjectsInCansCount,
        defectiveWeldingOnCansCount,
      } = this.localCanEndInspection;
      console.debug({
        cansWithSeamDefectsCount,
        dentedCansCountCount,
        rustedCansCount,
        scratchedCansCount,
        foreignObjectsInCansCount,
        defectiveWeldingOnCansCount,
      });
      // eslint-disable-next-line max-len
      this.localCanEndInspection.numberOfCansNotSuitableForCanning = parseInt(cansWithSeamDefectsCount ?? 0, 10)
        + parseInt(dentedCansCountCount ?? 0, 10)
        + parseInt(rustedCansCount ?? 0, 10)
        + parseInt(scratchedCansCount ?? 0, 10)
        + parseInt(foreignObjectsInCansCount ?? 0, 10)
        + parseInt(defectiveWeldingOnCansCount ?? 0, 10);

      console.debug(this.localCanEndInspection.numberOfCansNotSuitableForCanning);
      const { canEndsWithoutCompoundCount, scratchedCanEndsCount } = this.localCanEndInspection;
      // eslint-disable-next-line max-len
      this.localCanEndInspection.numberOfCanEndsNotSuitableForCanning = parseInt(canEndsWithoutCompoundCount ?? 0, 10)
        + parseInt(scratchedCanEndsCount ?? 0, 10);
    },
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localCanEndInspection);
        this.isSaving = true;
      }
    },
    handover(status) {
      this.localCanEndInspection.status = status;
      this.$emit('save', this.localCanEndInspection);
      this.isSaving = true;
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
<style scoped>
.v-input {
  align-items: center;
}
</style>
